import Component from './Component'

export default class GeoPicker extends Component {

	static _type = 'GeoPicker'

	form			// Parent form component

	input_els		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.frame = this.base.querySelector('.geo_picker_frame')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil

		// Init leaflet
		this._leaflet = L.map(this.frame).setView([ 47.175, 19.485 ], 6)

		// Init tileset for the map
		L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
		}).addTo(this._leaflet)

		const options = {
			draggable: true,
			autoPan: true,
			autoPanSpeed: 5
		}

		this._marker = L.marker([ 47.175, 19.485 ], options)

		// Register event handlers
		this._marker.on('move', this.inputListener)
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)		// node event
		if ('style_field' in this.params) {
			this.form.data.record.on(this.params.style_field + '-updated', this.styleUpdateListener)	// node event
		}

		if ('init' in this.params && typeof this.params.init == 'function') {
			this.params.init(this)
		}
	}

	refresh () {
		this._leaflet.invalidateSize()

		const value = this.form.data[this.params.name]
		if (Array.isArray(value)) {
			// Render marker
			const lat = parseFloat(value[0])
			const lng = parseFloat(value[1])
			if (!Number.isNaN(lat) && !Number.isNaN(lng)) {

				// We have coordinates, set location
				if (this._marker.getLatLng().lat != lat || this._marker.getLatLng().lng != lng) {
					const latlng = [ lat, lng ]
					this._marker.setLatLng(latlng)
					this._leaflet.panInside(latlng, { padding: [ 50, 50 ] })
				}

				// Set marker style
				if ('styles' in this.params && 'style_field' in this.params && this.params.style_field) {
					const style = this.params.styles.find(s => s.value == this.form.data[this.params.style_field])
					const icon = this._marker.getIcon()
					if ('options' in icon && icon.options.icon != style.icon) {
						this._marker.setIcon(L.AwesomeMarkers.icon({
							icon: style.icon,
							markerColor: 'red',
							prefix: 'fa',
							extraClasses: 'mt-2 pt-1'
						}))
					}
				}

				this._marker.addTo(this._leaflet)
			} else {
				// Invalid coordinates
				this._marker.removeFrom(this._leaflet)
			}
		} else {
			// No coordinates
			this._marker.removeFrom(this._leaflet)
		}
	}

	inputListener = (event) => {
		// Send data to the record
		const latlng = [ event.latlng.lat, event.latlng.lng ]
		this.form.data[this.params.name] = latlng
	}

	updateListener = (value, errors) => {

		// Refresh the map
		this.refresh()

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	styleUpdateListener = (value, errors) => {

		// Refresh the map
		this.refresh()
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').removeClass('is-invalid')
			}
			$(this.input_els).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').addClass('is-invalid')
			}
			$(this.input_els).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		this._marker.off('move', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)
		if ('style_field' in this.params) {
			this.form.data.record.off(this.params.style_field + '-updated', this.styleUpdateListener)
		}

		delete this.frame
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
